import { useEffect, useRef } from 'react';
import { CategoryCard } from '../components/worlds/CategoryCard';
import { CatalogError } from '../components/worlds/CatalogError';
import { WorldGrid } from '../components/worlds/WorldGrid';
import { Spinner } from '../components/common/Spinner';
import { useWorldCatalog } from '../hooks/useWorldCatalog';
import { getUncategorizedWorlds, getVisibleCategories } from '../utils/worldCategories';
import { getCatalogText } from '../utils/catalogText';

export function WorldMapPage() {
  const { manifest, worlds, loading, error, retry } = useWorldCatalog();
  const text = getCatalogText();
  const headingRef = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    if (loading) return;
    window.scrollTo({ top: 0, behavior: 'instant' });
    headingRef.current?.focus({ preventScroll: true });
  }, [loading]);
  if (loading) return <div className="flex min-h-screen items-center justify-center"><Spinner size="lg" /></div>;
  const categories = manifest ? getVisibleCategories(manifest, worlds) : [];
  const uncategorized = manifest ? getUncategorizedWorlds(manifest, worlds) : [];

  return <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 sm:py-10">
    <header className="mb-6 max-w-2xl">
      <p className="mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-primary-600 dark:text-primary-400">{text.worlds}</p>
      <h1 ref={headingRef} tabIndex={-1} className="text-3xl font-bold tracking-tight text-gray-900 outline-none dark:text-gray-100">{categories.length ? text.chooseCategory : text.worlds}</h1>
      {categories.length > 0 && <p className="mt-3 text-sm leading-relaxed text-gray-600 dark:text-gray-300">{text.introduction}</p>}
    </header>
    <CatalogError error={error} retry={retry} />
    {categories.length > 0 && <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {categories.map(({ category, worlds }) => <CategoryCard key={category.id} category={category} worldCount={worlds.length} />)}
    </div>}
    {uncategorized.length > 0 && <section className={categories.length ? 'mt-12' : ''}>
      {categories.length > 0 && <h2 className="mb-6 text-2xl font-bold text-gray-900 dark:text-gray-100">{text.otherWorlds}</h2>}
      <WorldGrid worlds={uncategorized} />
    </section>}
    {!error && categories.length === 0 && uncategorized.length === 0 && <p className="text-gray-600 dark:text-gray-300">{text.noWorlds}</p>}
  </div>;
}
